import { projectStatesRenderData } from "client/interfaces/ProjectStates";
import Separator from "client/components/layout/Separator";
import { LayoutOrientations } from "client/globals";
import ModalManager from "client/components/layout/ModalManager";
import { TooltipKeys } from "client/components/tooltips/TooltipKeys";
import { StoreActions } from "client/state/store";
import { IAppScenario } from "src/classes/api/GQL/scenarios/gql";
import { useTypedDispatch } from "src/state/hooks";
import LoadScenarioModal from "../dialogs/LoadScenarioModal";
import Spacer from "client/components/layout/Spacer";

interface IScenarioListItemProps
{
	scenario: IAppScenario;
	revisions?: IAppScenario[];
	index?: number;
}

const ScenarioListItem = (props: IScenarioListItemProps) => 
{
	const dispatch = useTypedDispatch();

	const isLoadable = 	props.scenario.currentRelease?.projectSaveFile?.file.fileUrl && 
						props.scenario.currentRelease?.projectSaveFile?.project?.id;
						
	const isRevision = !props.scenario.revisions || props.scenario.revisions.length <= 1;
	const faceValue = props.scenario.revisions ? props.scenario.revisionGroupName : props.scenario.revisionName;

	const stateRenderData = props.scenario.state ? projectStatesRenderData.get(props.scenario.state) : undefined;

	return (
		<div className={"scenarioItemRoot"}
			data-name={"scenario-item-root-" + faceValue}
			style={{
				opacity: !isLoadable ? 0.5 : undefined,
			}}
			onClick={() => 
			{
				if (isLoadable)
				{
					if(props.scenario.revisions && props.scenario.revisions.length > 1)
					{
						dispatch(StoreActions.worklink.setDashboardRevisionGroup({ name: props.scenario.revisionGroupName || "", id: props.scenario.id }));
					}
					else
					{
						ModalManager.addModal({ 
							content: <LoadScenarioModal scenario={props.scenario} revisions={props.revisions} index={props.index} />,
							allowClickOut: false,
							showBackdrop: true,
						});
					}
				}
			}}
			tooltip={isLoadable ? undefined : TooltipKeys.WebappScenarioCannotLoad}
		>
			<div className={"scenarioItemDetails"}
				data-name={"scenario-item-details"}
			>
				<div className={"scenarioItemTitle"}
					data-name={"scenario-name"}
				>
					{ faceValue }
				</div>
				<Spacer size={{ y: "4px" }} />
				<div className={"scenarioItemInfo caption2"}
					data-name={"scenario-item-info"}
				>
					{
						!isRevision ?
							<div>{ props.scenario.revisions?.length } revisions</div>
							:
							<>
								{ props.scenario.revisionName && <div>{ props.scenario.revisionName }</div> }
								{ props.scenario.revisionName && <Separator orientation={LayoutOrientations.Vertical} /> }
								{ props.scenario.publishedAt && <div>{ new Date(props.scenario.publishedAt!).toLocaleString() }</div> }
								{ props.scenario.publishedAt && stateRenderData && <Separator orientation={LayoutOrientations.Vertical} /> }
								{ stateRenderData && <div style={{ color: stateRenderData?.color }}>{ stateRenderData?.label }</div> }
							</>
					}
				</div>
			</div>
			{/* TODO: the chevron should only display for resumable scenarios; we don't support those yet
			{
				isLoadable === true &&
					<ChevronRight scale={2} />
			} */}
		</div>
	);
};

export default ScenarioListItem;